/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidSchemeModel } from '../../models/medical-aid-scheme-model';

export interface MedicalAidMedicalAidSchemeSaveMedicalAidIdPost$Params {
  medicalAidId: string;
      body?: MedicalAidSchemeModel
}

export function medicalAidMedicalAidSchemeSaveMedicalAidIdPost(http: HttpClient, rootUrl: string, params: MedicalAidMedicalAidSchemeSaveMedicalAidIdPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, medicalAidMedicalAidSchemeSaveMedicalAidIdPost.PATH, 'post');
  if (params) {
    rb.path('medicalAidId', params.medicalAidId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

medicalAidMedicalAidSchemeSaveMedicalAidIdPost.PATH = '/MedicalAid/MedicalAidSchemeSave/{medicalAidId}';
